import { Col, Container, Row } from "react-bootstrap";
import { ReactNode } from "react";
import "./PayoutOnboardingShell.scss";

interface PayoutOnboardingShellProps {
  title: string;
  subtitle?: string;
  icon: ReactNode;
  children: ReactNode;
}

export function PayoutOnboardingShell( {
  title,
  subtitle,
  icon,
  children,
}: PayoutOnboardingShellProps ) {
  return (
    <div className="payout-onboarding-page">
      <Container>
        <Row className="justify-content-center">
          <Col xs={12} md={10} lg={7} xl={6}>
            <div className="payout-onboarding-brand">
              <img src="/spotsync-logo.svg" alt="SpotSync" />
            </div>

            <div className="payout-onboarding-card">
              <div className="payout-onboarding-card-header">
                <div className="payout-onboarding-card-header-row">
                  <div className="payout-onboarding-card-header-icon">{icon}</div>
                  <div>
                    <h1 className="payout-onboarding-card-title">{title}</h1>
                    {subtitle && (
                      <p className="payout-onboarding-card-subtitle">{subtitle}</p>
                    )}
                  </div>
                </div>
              </div>
              <div className="payout-onboarding-card-body">{children}</div>
            </div>

            <div className="payout-onboarding-footer">
              SpotSync · Secure payouts powered by Stripe
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}
